import { ApiProperty } from "@nestjs/swagger";

export class CodeListMainId{
    @ApiProperty()
    codeListMainId : number;
}